module.exports = __webpack_public_path__ + "media/images/navbar/donate_warning/Dark-ff0dcfb22ad336cad893940c9fe852a2.png";